export function isUrlExternal(target: string): boolean {
  return /^(https?:|mailto:|tel:|ftp:|file:|data:|blob:|sms:|whatsapp:|geo:|magnet:)/.test(target) || !target.startsWith('/')
}
